import { Button as NUIButton } from "@nextui-org/button";
import { extendVariants } from "@nextui-org/system";

export const Button = extendVariants(NUIButton, {
  variants: {
    size: {
      sm: "rounded-sm font-offbit-bold tracking-wider",
      md: "rounded-sm font-offbit-bold tracking-wider",
      lg: "rounded-sm font-offbit-bold tracking-wider",
    },
  },
  defaultVariants: {
    size: "md",
  },
});
